import { createAction } from 'redux-act';

const openMessageModal = createAction('OPEN_MESSAGE_MODAL', data => data);
const openMessageModalDuration = createAction('OPEN_MESSAGE_MODAL_DURATION', data => data);
const closeMessageModal = createAction('CLOSE_MESSAGE_NOTIFICATION');
const openDialog = createAction('OPEN_DIALOG');
const closeDialog = createAction('CLOSE_DIALOG');
const openSnackbar = createAction('OPEN_SNACKBAR', data => data);
const closeSnackbar = createAction('CLOSE_SNACKBAR');

const getNotificationRequest = createAction('GET_NOTIFICATION_REQUEST', data => data);
const getNotificationSuccess = createAction('GET_NOTIFICATION_SUCCESS', data => data);
const getNotificationError = createAction('GET_NOTIFICATION_ERROR');

const deleteNotificationRequest = createAction('DELETE_NOTIFICATION_REQUEST', data => data);
const deleteNotificationSuccess = createAction('DELETE_NOTIFICATION_SUCCESS', data => data);
const deleteNotificationError = createAction('DELETE_NOTIFICATION_ERROR');

const updateNotificationRequest = createAction('UPDATE_NOTIFICATION_REQUEST', data => data);
const updateNotificationSuccess = createAction('UPDATE_NOTIFICATION_SUCCESS', data => data);
const updateNotificationError = createAction('UPDATE_NOTIFICATION_ERROR');

const deleteAllNotificationRequest = createAction('DELETE_ALL_NOTIFICATION_REQUEST', data => data);
const deleteAllNotificationSuccess = createAction('DELETE_ALL_NOTIFICATION_SUCCESS', data => data);
const deleteAllNotificationError = createAction('DELETE_ALL_NOTIFICATION_ERROR');

const clearNotification = createAction('HANDLE_CLEAR_NOTIFICATION', data => data);

export default {
  openMessageModal,
  openMessageModalDuration,
  closeMessageModal,
  openDialog,
  closeDialog,
  openSnackbar,
  closeSnackbar,

  getNotificationRequest,
  getNotificationSuccess,
  getNotificationError,

  deleteNotificationRequest,
  deleteNotificationSuccess,
  deleteNotificationError,

  updateNotificationRequest,
  updateNotificationSuccess,
  updateNotificationError,


  deleteAllNotificationRequest,
  deleteAllNotificationSuccess,
  deleteAllNotificationError,

  clearNotification
};
